<template>
  <div class="sticky-top">
    <!-- Progress Bar -->
    <ProgressBar class="d-none" :formData="formData" />
    <!-- Save Button -->
    <SaveButton
      v-if="!exportMode"
      :formData="formData"
      @onSaveEvent="
        $emit('onSaveEvent');
        toggleMessage();
      "
    />
    <div v-show="unsavedChanges">
      <SaveMessage
        message="You have unsaved changes."
        savedStyle="alert alert-danger border-danger"
        textStyle="fw-bold text-center mb-0"
      />
    </div>
    <div v-show="showSave">
      <SaveMessage
        message="Changes saved."
        savedStyle="alert alert-success border-success"
        textStyle="fw-bold text-center mb-0"
      />
    </div>
  </div>
</template>

<script>
import ProgressBar from "@/components/sidebar/ProgressBar";
import SaveButton from "@/components/sidebar/SaveButton";
import SaveMessage from "@/components/sidebar/SaveMessage";
export default {
  name: "LabSidebar",
  props: {
    exportMode: Boolean,
    formData: Object,
    unsavedChanges: Boolean
  },
  data() {
    return {
      showSave: false
    };
  },
  components: {
    ProgressBar,
    SaveButton,
    SaveMessage
  },
  methods: {
    toggleMessage() {
      this.showSave = true;
      setTimeout(() => {
        this.showSave = false;
      }, 1500);
    }
  }
};
</script>
